import * as lmsReportAction from "../actions/lmsReportAction";
import { lmsReportType } from "../constants/lmsReportType";
import {
  getLmsDashboardReport,
  getLmsDashboardReportDetails,
  getLmsReport,
  getLmsReportCourse,
  getLmsReportLesson,
  getLmsDashboardCourseLessonSafetyMeetingCompleted,
  getLmsDashboardCourseLessonSafetyMeetingInCompleted,
} from "../../services/lmsReportService";
import { call, put, takeLatest } from "redux-saga/effects";
import { apiError } from "../../utils/helper";

export function* getLmsReportSaga(param) {
  const payload = param.data;

  try {
    const { data, status, error } = yield call(getLmsReport, payload);
    if (!data && status !== 200) throw apiError(error);
    const lmsReportPage = lmsReportType.LMS_REPORT_PAGE;
    yield put(
      lmsReportAction.lmsReportSuccess({
        lmsReportPage,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Create Case Failed" };
    yield put(lmsReportAction.lmsReportFailure(data));
  }
}

export function* getLmsReportCourseSaga(param) {
  const payload = param.data;

  try {
    const { data, status, error } = yield call(getLmsReportCourse, payload);
    if (!data && status !== 200) throw apiError(error);
    const lmsReportCoursePage = lmsReportType.LMS_REPORT_COURSE_PAGE;
    yield put(
      lmsReportAction.getLmsReportCourseSuccess({
        lmsReportCoursePage,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Lms Report Course Failed" };
    yield put(lmsReportAction.getLmsReportCourseFailure(data));
  }
}

export function* getLmsReportLessonSaga(param) {
  const payload = param.data;

  try {
    const { data, status, error } = yield call(getLmsReportLesson, payload);
    if (!data && status !== 200) throw apiError(error);
    const lmsReportLessonPage = lmsReportType.LMS_REPORT_LESSON_PAGE;
    yield put(
      lmsReportAction.getLmsReportLessonSuccess({
        lmsReportLessonPage,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Lms Report Lesson Failed" };
    yield put(lmsReportAction.getLmsReportLessonFailure(data));
  }
}

export function* getLmsDashboardReportSaga(param) {
  const payload = param.data;

  try {
    const { data, status, error } = yield call(getLmsDashboardReport, payload);
    if (!data && status !== 200) throw apiError(error);
    // const lmsReportLessonPage = lmsReportType.LMS_REPORT_LESSON_PAGE;
    yield put(
      lmsReportAction.getLmsDashboardReportSuccess({
        // lmsDashboardReportPage,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Lms Dashboard Report  Failed" };
    yield put(lmsReportAction.getLmsDashboardReportFailure(data));
  }
}

export function* getLmsDashboardReportDetailsSaga(param) {
  const payload = param.data;

  try {
    const { data, status, error } = yield call(
      getLmsDashboardReportDetails,
      payload
    );
    if (!data && status !== 200) throw apiError(error);
    // const lmsReportLessonPage = lmsReportType.LMS_REPORT_LESSON_PAGE;
    yield put(
      lmsReportAction.getLmsDashboardReportDetailsSuccess({
        // lmsDashboardReportPage,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Lms Dashboard Report Details Failed" };
    yield put(lmsReportAction.getLmsDashboardReportDetailsFailure(data));
  }
}
export function* getLmsDashboardCourseLessonSafetycompletedSaga(param) {
  const payload = param.data;

  try {
    const { data, status, error } = yield call(
      getLmsDashboardCourseLessonSafetyMeetingCompleted,
      payload
    );
    if (!data && status !== 200) throw apiError(error);
    // const lmsReportLessonPage = lmsReportType.LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED_PAGE;
    yield put(
      lmsReportAction.getCourseLessonSafetyMeetingCompleteSuccess({
        // lmsDashboardReportPage,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : {
            message:
              error || "Lms Dashboard Report Course Lesson safety comp failed",
          };
    yield put(
      lmsReportAction.getCourseLessonSafetyMeetingCompleteFailure(data)
    );
  }
}
export function* getLmsDashboardCourseLessonSafetyIncompletedSaga(param) {
  const payload = param.data;

  try {
    const { data, status, error } = yield call(
      getLmsDashboardCourseLessonSafetyMeetingInCompleted,
      payload
    );
    if (!data && status !== 200) throw apiError(error);
    const lmsReportLessonPage =
      lmsReportType.LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED_PAGE;
    yield put(
      lmsReportAction.getCourseLessonSafetyMeetingInCompleteSuccess({
        lmsReportLessonPage,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : {
            message:
              error ||
              "Lms Dashboard Report Course Lesson safety Incomp failed",
          };
    yield put(
      lmsReportAction.getCourseLessonSafetyMeetingInCompleteFailure(data)
    );
  }
}
const myReportSaga = [
  takeLatest(lmsReportType.GET_LMS_REPORT_PENDING, getLmsReportSaga),
  takeLatest(
    lmsReportType.GET_LMS_REPORT_COURSE_PENDING,
    getLmsReportCourseSaga
  ),
  takeLatest(
    lmsReportType.GET_LMS_REPORT_LESSON_PENDING,
    getLmsReportLessonSaga
  ),
  takeLatest(
    lmsReportType.GET_LMS_DASHBOARD_REPORT_PENDING,
    getLmsDashboardReportSaga
  ),
  takeLatest(
    lmsReportType.GET_LMS_DASHBOARD_REPORT_DETAILS_PENDING,
    getLmsDashboardReportDetailsSaga
  ),
  takeLatest(
    lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_PENDING,
    getLmsDashboardCourseLessonSafetycompletedSaga
  ),
  takeLatest(
    lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_PENDING,
    getLmsDashboardCourseLessonSafetyIncompletedSaga
  ),
];

export default myReportSaga;
